import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CIVILISATION_ID , IPFS_URL } from '../../../app/constants'
import { ChevronUp, Cross } from '../../../assets/img'
import { cardCalculator } from '../../../utilities/CardCalculator'
import { CivilisationTitle } from '../../containers/CivilisationTitle'
import Button from '../Button'
import { getStakeInfo } from '../../../features/staking/stakeInfoSlice.js'
import { SelectCardPopup } from './SelectCardPopup'
import StakeCard from './StakeCard'


const StakeSlot = ({
  title,
  civilisation,
  mission,
  userStake,
  stakeSlotId,
  templateId,
  type,
  userCards,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user)
  const cards = useSelector((state) => state.userCollection.detailedCollection)
  const fullCollection = useSelector(
    (state) => state.galaktikaCollection.fullNFTCollection,
  )

  // FIXME_CHANGE WITH DYNAMIC DATA WHEN STAKE SLOTS ARE PRESENT FOR EACH EPOCH
  // const epoch = 0

  const stakeSlots = useSelector((state) => state.stakeInfo.stakeSlots)
  const stakeSlot = stakeSlots.find(
    (e) =>
      e.mission === mission &&
      e.nft_type_id === type &&
      e.civilization === CIVILISATION_ID[civilisation],
  )

  // const stakedSlots = useSelector((state) => state.stakeInfo.userNFTStakingDetails)
  // const stakedSlot = stakeSlot && stakedSlots.filter(
  //   (e) => e.stake_slot_id === stakeSlot[0].id && e.epoch_id === epoch
  // );

  const epochDetails = useSelector(state => state.epoch.epochDetails)

  const epoch_id = epochDetails.find(
    e =>
    e.mission === mission &&
    e.civilization === CIVILISATION_ID[civilisation],
  )?.id

  const [stakedCards, setStakedCards] = useState([])

  // Calculate how many cards the user can stake and disable adding more card when limit is reached

  const cardNumber = cardCalculator(userStake)
  const [isDisabled, setIsDisabled] = useState(false)

  useEffect(() => {
    if (stakedCards.length === cardNumber) {
      setIsDisabled(true)
    } else {
      setIsDisabled(false)
    }
  }, [stakedCards])

  // Filter User Collection with Cards allowed in each slot

  function filterCardSlot() {
    const cardSlotArr = templateId

    const filteredCards = cards.filter((item) =>
      cardSlotArr.includes(item.cardTemplateId),
    )

    const fullColFilteredCards = fullCollection?.filter((item) =>
      cardSlotArr.includes(item.template_id),
    )

    const stakeCards = (filteredCards) => {
      if (filteredCards[0]) {
        return filteredCards
      } else {
        return fullColFilteredCards
      }
    }
    setCard(stakeCards(filteredCards))
  }

  // Handle Staking

  const [isOpen, setIsOpen] = useState(false)
  const [card, setCard] = useState([])

  function handleOpen(cardTitle) {
    setIsOpen(true)
    filterCardSlot()
  }

  function handleClose() {
    setIsOpen(false)
  }

  function handleCardStake(card) {
    console.log('DEBUGGING STAKE SLOT', card)
    setStakedCards((prevState) => {
      return [card.uniqueId, ...prevState]
    })
  }

  function handleCardUnstake(card) {
    const newStakeCards = stakedCards.filter((item) => item !== card.uniqueId)
    setStakedCards(newStakeCards)
  }

  const sparksAmount = useSelector(state => state.stakeInfo.sparksAmount);

  const handleStake = (event, spark = false) => {
    event.preventDefault()
    const stakedCardsInt64 = []
    stakedCards.forEach((item) => stakedCardsInt64.push(parseInt(item)))

    let isSpark = spark
    if (sparksAmount >= 10) {
      isSpark = false
    }
    
    const stake = async (spark = isSpark) => {
      try {
        const result = await user.userAccount.signTransaction(
          {
            actions: [
              {
                account: 'atomicassets',
                name: 'transfer',
                authorization: [
                  {
                    actor: user.accountName,
                    permission: user?.requestPermission || 'active',
                  },
                ],
                data: {
                  from: user.accountName,
                  to: 'gtokenstakin',
                  asset_ids: stakedCards,
                  memo: spark ? `stake spark@${epoch_id}` : `stake nft@${
                    stakeSlot ? stakeSlot.id : 'undefined'
                  }@${CIVILISATION_ID[civilisation]}@${mission}@${sparksAmount}`,
                },
              },
            ],
          },
          {
            blocksBehind: 3,
            expireSeconds: 1200,
          },
        )
        console.log('DEBUGGING STAKE ACTION:', result, spark ? epoch_id : mission, )
        console.log(
          'DEBUGGING STAKE ACTION: ',
          mission,
          type,
          CIVILISATION_ID[civilisation],
        );
        dispatch(getStakeInfo());
      } catch (error) {
        console.log('DEBUGGING STAKE ACTION:', error)
        console.log(
          'DEBUGGING STAKE ACTION: ',
          mission,
          type,
          CIVILISATION_ID[civilisation],
          stakeSlot
        )

        if (error === 'You already stake nft for this civilization') {
          alert('You have already staked NFTs for this civilization')
          setStakedCards([])
          setIsOpen(false)
        }
      }
    }
    stake()
    setIsOpen(false)
  }

  useEffect(() => {
    console.log('DEBUGGING USERCARDS', userCards)
  })


  return (
    <>
      <SelectCardPopup isOpen={isOpen} onClose={handleClose} card={card}>
        <div id="top" className="flex items-center justify-between pt-5 px-10">
          <CivilisationTitle civilisation={civilisation} />
          <div className="flex gap-5">
            <div>
              <h3 className="text-gold">
                Total MP:{' '}
                <span className="text-white">
                  {isNaN(parseInt(userCards?.total_power)?.toFixed(2))
                    ? 0
                    : parseInt(userCards?.total_power)?.toFixed(2)}
                </span>
              </h3>
              <p className="text-cyanBlue">Stake {cardNumber} Cards</p>
            </div>
            <button
              onClick={handleClose}
              className="text-cyanBlue transition-all duration-300 hover:text-white"
            >
              <Cross classname="h-12 w-12" />
            </button>
          </div>
        </div>
        <div className="flex w-full p-10 pt-5 overflow-auto justify-center">
          <div className="flex flex-row flex-wrap gap-10">
            {card &&
              card.map((card, i) => (
                <StakeCard
                  key={card.mint ?? i}
                  handleCardStake={() => handleCardStake(card)}
                  handleCardUnstake={() => handleCardUnstake(card)}
                  isStaked={stakedCards.includes(card.uniqueId)}
                  mint={card.mint}
                  assetId={card.template_id}
                  image={card.image ?? card.immutable_data.img}
                  video={card.video ?? card.immutable_data.video}
                  name={card.name}
                  notInUserWallet={!card.mint}
                  disabled={isDisabled}
                  userCards={userCards}
                />
              ))}
          </div>
        </div>
        <Button
          className="block mx-auto mb-9"
          onClick={(event) => handleStake(event, title === "Spark")}
          active
        >
          Stake Selected
        </Button>
        <div className="absolute bottom-10 right-10 w-14 h-14">
          <a href="#top">
            <ChevronUp classname="text-cyanBlue hover:text-white duration-300 transition-all w-14 h-14" />
          </a>
        </div>
      </SelectCardPopup>
      <div
        onClick={() => {if (title === "Spark" || sparksAmount > 0)  handleOpen(title)}}
        className={"flex flex-col col-span-1 " + (title === "Spark" ? sparksAmount >= 10 ? " cursor-not-allowed" : " cursor-pointer" : sparksAmount > 0 ? " cursor-pointer" : " cursor-not-allowed")}
        // style={card.title === stakedCards[card.title]? back}
      >
        <div className={"border card-ratio flex items-center justify-center relative" + (title === "Spark" ? sparksAmount >= 10 ? " border-[#a4a4a4]" : " border-cyanBlue" : sparksAmount > 0 ? " border-cyanBlue" : " border-[#a4a4a4]")}>
          <div className="absolute">
            {
            userCards?.map((el, i) => {
              return (
                <div key={i}>
                {el?.data[0].video ? (
              <video
                autoPlay
                loop
                muted
                src={`${IPFS_URL}${el?.data[0].video}`}
              />
            ) : el?.data[0].img ? (
              <img
                alt={el?.data.name}
                src={`${IPFS_URL}${el?.data[0].img}`}
                loading="lazy"
              />
            ) : null}
                </div>
              )
            })

            
            }
          </div>
          <p className="text-white max-w-[120px] text-center">
            Assign {title} Card
          </p>
        </div>
        <p className="text-white pt-2">
          Mission Power:{' '}
          {
            // userCards?.reduce(
            //   (a, b) => {
            //     return parseInt(a.total_power) + parseInt(b.total_power)
            //   },
            //   { total_power: 0 },
            // ) ||

            isNaN(parseInt(userCards?.length > 0 ? (userCards[0]?.total_power) : 0 )?.toFixed(2))
              ? 0
              : parseInt(userCards?.length > 0 ? (userCards[0]?.total_power) : 0 )?.toFixed(2)
          }
        </p>
      </div>
    </>
  )
}

export default StakeSlot
